import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';

const CartIsFullMessage = () => {
  const { ringCount, hasMaxRingCount } = useWizardStateContext();
  const t = useTranslations();

  return (
    <>
      {hasMaxRingCount && (
        <Typography className="border-b border-gray-300/50 pb-5 text-base font-medium">
          {t('cart_full_ring_limit', {
            amount: ringCount,
          })}
        </Typography>
      )}
    </>
  );
};

export default CartIsFullMessage;
